<script setup lang="ts">
import { mockNewsItems } from "~/assets/ts/announcementItems";

useSeoMeta({
	title: "株式会社Bang",
	description:
		"「すべての悩みに答えを」株式会社Bangはいつでもどこでも手軽に保険に加入できる利便性を軸に、ライフスタイルに合わせた最適なサービスをご提供する保険代理店です。",

	// OGP設定
	ogTitle: "株式会社Bang",
	ogDescription:
		"「すべての悩みに答えを」株式会社Bangはいつでもどこでも手軽に保険に加入できる利便性を軸に、ライフスタイルに合わせた最適なサービスをご提供する保険代理店です。",
	ogUrl: "https://www.bang-inc.jp/",
});
</script>

<template>
  <!-- メインページコンテンツ -->
  <main class="main-content">
    <!-- 主视图エリア（メインビジュアル） -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">すべての悩みに<br class="button-sp"><span class="hero-title-highlight">答え</span>を</h1>
        <p class="hero-subtitle">Answers for every concern.</p>
      </div>
    </section>

    <!-- お知らせセクション -->
    <section class="news-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">お知らせ</h2>
          <p class="section-description">News</p>
        </div>
        <AnnouncementContainer :items="mockNewsItems" :isHomePage="true" />

        <!-- SP/PC用ボタン -->
        <ButtonPrimary class="button-sp" size="md" buttonType="info">お知らせ一覧を見る</ButtonPrimary>
        <ButtonPrimary class="button-pc" size="lg" buttonType="info">お知らせ一覧を見る</ButtonPrimary>

      </div>
    </section>

    <!-- サービスセクション -->
    <section class="service-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">サービス</h2>
          <p class="section-description">Service</p>
        </div>
        <div class="service-content">
          <!-- サービスアイコンリスト -->
          <div class="service-box">
            <img src="../assets/images/insurance.png" alt="損害保険のご案内" class="service-item" />
            <!-- <img src="../assets/images/car.png" alt="自賠責保険のご案内" class="service-item" /> -->
            <!-- <img src="../assets/images/life.png" alt="生命保険のご案内" class="service-item" /> -->
            <img src="../assets/images/ad.png" alt="広告・プロモーション支援" class="service-item" />
            <!-- <img src="../assets/images/call-center.png" alt="コールセンターサービス" class="service-item" /> -->
            <!-- <img src="../assets/images/short.png" alt="少額短期保険のご案内" class="service-item" /> -->
            <!-- <img src="../assets/images/information.png" alt="情報処理・提供サービス" class="service-item" /> -->
            <img src="../assets/images/net.png" alt="インターネットサービス" class="service-item" />
            <img src="../assets/images/consulting.png" alt="保険・広告コンサルティング" class="service-item" />
          </div>
        </div>
      </div>
    </section>

    <!-- 会社概要セクション -->
    <section class="company-section">
      <div class="section-container">
        <div class="section-header">
          <h2 class="section-title">会社概要</h2>
          <p class="section-description">Company</p>
        </div>
        <div class="company-content">
          <!-- 企業情報カード -->
          <CardService />
        </div>
      </div>
    </section>
  </main>
</template>

<style scoped lang="scss">
// マインビジュアルはみ出した高さ
$header-overflow: 2rem; // 32px

.button-sp {
  display: block;
  margin: auto;
}

.button-pc {
  display: none;
  margin: auto;
}

// メインコンテンツのスタイル
.main-content {
  width: 100%;
}

// 共通セクションスタイル
.news-section,
.service-section,
.company-section {
  position: relative;

  // 円環背景を疑似要素で作成
  &::before {
    content: '';
    position: absolute;
    width: 20rem; // 320px
    height: 20rem; // 320px
    aspect-ratio: 1/1;
    box-sizing: border-box;
    border-radius: 20rem; // 320px
    border: 1.5rem solid #EFF7FF; // 24px
    z-index: -1; // コンテンツの背景に配置
    pointer-events: none; // クリックイベントを通す
  }
}

.news-section {
  padding: calc(3rem - $header-overflow) 1rem 4rem 1rem;
}

.news-section::before {
  top: 50%;
  transform: translateY(-50%);
  left: -3rem; // -48px
}

.service-content {
  width: 100%;
  max-width: 30rem;
  margin: auto;
}

.service-section {
  padding: 2.5rem 0.75rem 4rem 0.75rem;
  overflow: hidden;
}

.service-section::before {
  top: 3.5rem; // 56px
  right: -3rem; // -48px
}

.company-section {
  padding: 2.5rem 1rem 4rem 1rem;
}

.company-section::before {
  top: 2rem;
  left: -3rem; // -48px
}

.section-container {
  width: min(91vw, 64.5rem);
  margin: auto;
}

.section-header {
  text-align: center;
  margin-bottom: 1.5rem; // 24px
}

.section-title {
  font-size: 1.75rem; // 28px
  font-weight: 700;
}

.section-description {
  color: #4896DC;
  font-size: 1rem; // 16px
  font-weight: 700;
}

.service-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 1rem;

  .service-item {
    flex: 0 0 calc((100% - 0.75rem) / 2); // 2個のアイテムを横並び
  }
}

.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  object-fit: contain;
  max-width: 10rem; // 160px
  max-height: 8.75rem; // 140px
  width: auto;
  height: auto;
}

.company-content {
  margin-top: 1.5rem;
}

// ヒーローセクションのスタイル
.hero-section {
  position: relative;
  height: calc(25rem + $header-overflow); // 400px
  max-height: calc(25rem + $header-overflow); // 400px
  transform: translateY(-$header-overflow);
  background-image: url('../assets/images/heroSection_max750.jpg');
  background-color: white;
  background-size: auto 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-content {
  text-align: center;
  transform: translateY(1.25rem);
}

.hero-title {
  font-size: 2rem; // 32px
  font-weight: 700;
  color: black;
  line-height: 125%;
}

.hero-title-highlight {
  color: #2174C0;
  line-height: 150%;
}

.hero-subtitle {
  color: #4896DC;
  font-size: 1rem; // 16px
  font-weight: 700;
  line-height: 150%;
}

// PC用のスタイル
@include mixin.media(pc) {

  // マインビジュアルはみ出した高さ
  $header-overflow: 2.25rem; // 36px

  .hero-section {
    height: calc(35rem + $header-overflow);
    max-height: calc(35rem + $header-overflow);
    background-image: url('../assets/images/heroSection_min751.jpg'); // PC用
    transform: translateY(-$header-overflow);
  }

  .hero-content {
    transform: translateY(1.125rem);
  }

  .hero-title {
    font-size: 3rem; // 48px
  }

  .hero-subtitle {
    font-size: 1.5rem; // 24px
  }

  .button-sp {
    display: none;
  }

  .button-pc {
    display: block;
  }

  .section-header {
    display: flex;
    margin-bottom: 0;
  }

  .news-section {
    padding: calc(3rem - $header-overflow) 1rem 4rem 1rem;
  }

  .service-section {
    padding: 2.5rem 1rem 5rem 1rem;
  }

  .service-section::before {
    top: 0rem; // -32px
  }

  .company-section {
    padding: 1.5rem 1rem 4rem 1rem;
  }

  .company-section::before {
    top: 3rem;
  }



  .section-title {
    font-size: 1.75rem; // 28px
  }

  .section-description {
    font-size: 1.5rem; // 24px
    margin: auto 0 auto 1rem;
  }

  .service-content {
    width: 100%;
    max-width: 64.5rem; // 1032px / 1280px
    margin-top: 1.5rem; // 24px
  }

  .service-box {
    gap: 0rem;

    .service-item {
      flex: 0 0 calc((100% - 6rem) / 4); // 4個のアイテムを横並び

      max-width: unset;
    }

    .service-icon {
      width: 5rem; // 80px
      height: 5rem; // 80px
      margin-bottom: 1rem;
    }
  }
}
</style>